import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import FaAngleDown from 'react-icons/lib/fa/angle-down';
import FaAngleUp from 'react-icons/lib/fa/angle-up';

import Styles from './ProjectListTableHeader.style';
import ListStyle from '../../ProjectList.styles';

const SortDirectionIcon = (direction) => {
  if (direction === 'desc') {
    return <FaAngleDown style={Styles.sortIcon} size={16} />;
  }
  return <FaAngleUp style={Styles.sortIcon} size={16} />;
};

class ProjectListTableHeader extends Component {
  constructor(props) {
    super(props);
    this.onSort = this.onSort.bind(this);
  }

  onSort(value) {
    this.props.onSort(value);
  }

  renderColumn({ column, style = {}, label = '' }) {
    const selected = this.props.sort.key === column;
    const selectedStyle = selected
      ? { borderBottom: '2px solid rgb(23, 232, 128)', fontWeight: 'bold' }
      : {};
    return (
      <div
        key={column}
        role="button"
        tabIndex={0}
        style={[Styles.headerCell, style, selectedStyle]}
        onClick={() => this.onSort(column)}
      >
        <span>{label ? label.toUpperCase() : column.toUpperCase()}</span>
        <span>{selected && SortDirectionIcon(this.props.sort.direction)}</span>
      </div>
    );
  }

  render() {
    const { batchEdit } = this.props;

    return (
      <header style={Styles.head}>
        {batchEdit && <div style={[Styles.headerCell, ListStyle.checkboxCell]} />}
        {this.renderColumn({ column: 'name', style: ListStyle.descriptionCell(batchEdit) })}
        {this.renderColumn({ column: 'createdAt', label: 'date', style: ListStyle.dateCell })}
        {this.renderColumn({ column: 'size' })}
        <div style={Styles.headerCell} />
      </header>
    );
  }
}

ProjectListTableHeader.propTypes = {
  batchEdit: PropTypes.bool.isRequired,
};

export default Radium(ProjectListTableHeader);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListTableHeader/ProjectListTableHeader.js